import { Grid } from "@mantine/core";
import ProductGroupForm from "./ProductGroupForm";
import ProductList from "src/modules/Product/ProductList";
import VariantMetricList from "../VariantMetric/VariantMetricList";
import ProductProvider from "src/api/context/ProductContext";
import useWritePermission from "src/hooks/usePermission";
import { EMPLOYEE_ROLE_OBJ } from "src/utils/constants";

export default function ProductGroupDetail() {
  const isAllowWrite = useWritePermission(EMPLOYEE_ROLE_OBJ.locProducts);
  return (
    <ProductProvider>
      <Grid
        sx={{ width: "100%", justifyContent: "center", height: "100%" }}
        gutterMd={"xl"}
      >
        <Grid.Col span={12} lg={6}>
          <ProductGroupForm isAllowWrite={isAllowWrite} />
          <VariantMetricList isAllowWrite={isAllowWrite} />
        </Grid.Col>

        <Grid.Col span={12} lg={6}>
          <ProductList isAllowWrite={isAllowWrite} />
        </Grid.Col>
      </Grid>
    </ProductProvider>
  );
}
